var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multiselect-wrapper" },
    [
      _c(
        "vue-multiselect",
        {
          attrs: {
            options: _vm.selectOptions,
            label: _vm.label,
            "track-by": _vm.trackBy,
            "open-direction": _vm.openDirection,
            searchable: true,
            disabled: _vm.disabled,
            "allow-empty": _vm.allowEmpty,
            placeholder: null,
            "select-label": "Wybierz",
            "deselect-label": "Odznacz",
            "selected-label": "Wybrane"
          },
          model: {
            value: _vm.objectValue,
            callback: function($$v) {
              _vm.objectValue = $$v
            },
            expression: "objectValue"
          }
        },
        [
          _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
            _vm._v("Brak wyników. Spróbuj zmienić wpisywaną frazę.")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPlaceholderVisible,
              expression: "isPlaceholderVisible"
            }
          ],
          staticClass: "multiselect-placeholder"
        },
        [_vm._v(_vm._s(_vm.placeholder))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e759a54e", { render: render, staticRenderFns: staticRenderFns })
  }
}